import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { downloadFile } from 'utils/download-file';
import { useEmendaParlamentarDetailsDispatch } from './emenda-parlamentar-details-context';
import { ACTION_TYPES } from './emenda-parlamentar-details-reducer';

export const useEmendaParlamentarDetailsController = () => {
  const dispatch = useEmendaParlamentarDetailsDispatch();

  const loadEmendaDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getEmendaParlamentar(id);

      dispatch({ type: ACTION_TYPES.setEmendaDetails, payload: response });
    } catch (error) {
      console.error('Error loading emenda details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes da emenda parlamentar' });
      dispatch({ type: ACTION_TYPES.setEmendaDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearEmendaDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setEmendaDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  const exportEmendaDetail = useCallback(async (id: number, format: string) => {
    const file = await MunicipalPortalAAppService.exportEmendaParlamentarDetail(id, format);
    downloadFile(file);
  }, []);

  return {
    loadEmendaDetails,
    clearEmendaDetails,
    exportEmendaDetail,
  };
};
